function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState as t, useEffect as u } from "react";
import { formatDate as m } from "./index.es643.js";
import "./index.es434.js";
import { DATE_MASK_VALUE as S } from "./index.es652.js";
import { isValidDate as g } from "./index.es686.js";
var L = function L(e, D) {
  var _t = t(""),
    _t2 = _slicedToArray(_t, 2),
    i = _t2[0],
    l = _t2[1],
    _t3 = t([null, null]),
    _t4 = _slicedToArray(_t3, 2),
    h = _t4[0],
    r = _t4[1],
    _t5 = t(!1),
    _t6 = _slicedToArray(_t5, 2),
    n = _t6[0],
    v = _t6[1],
    _t7 = t(!1),
    _t8 = _slicedToArray(_t7, 2),
    c = _t8[0],
    a = _t8[1],
    _t9 = t(null),
    _t0 = _slicedToArray(_t9, 2),
    A = _t0[0],
    f = _t0[1],
    _t1 = t([null, null]),
    _t10 = _slicedToArray(_t1, 2),
    p = _t10[0],
    V = _t10[1],
    o = i.slice(0, S.length),
    s = i.slice("".concat(S, " \u2014 ").length),
    E = function E() {
      r([null, null]), l(""), f(null);
    };
  return u(function () {
    var _D$current;
    n && a(!0), !n && document.activeElement === D.current && ((_D$current = D.current) === null || _D$current === void 0 ? void 0 : _D$current.blur());
  }, [n]), u(function () {
    g(o) && V([new Date(o), p[1]]), g(s) && V([p[0], new Date(s)]);
  }, [o, s]), u(function () {
    a(!1), l(e ? e.map(m).join(" — ") : "");
  }, [e]), u(function () {
    r([null, null]), f(null), e && e[0] && e[1] && l([m(e[0]), m(e[1])].join(" — ")), !c && !e && E();
  }, [c]), {
    from: o,
    to: s,
    setInputValue: l,
    selectedDates: h,
    setSelectedDates: r,
    isFocused: n,
    setIsFocused: v,
    isOpen: c,
    setIsOpen: a,
    hoveredDate: A,
    setHoveredDate: f,
    onClear: E,
    inputValue: i
  };
};
export { L as useRangeState };